import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { AmountFormatted } from '@root/shared/core/format'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type HolderTableRemainingCellProps = {
  balanceInUsd: BigNumber
  balanceInUsdPercentage: BigNumber
} & ClassNameProps
export const HolderTableRemainingCell = (
  props: HolderTableRemainingCellProps,
) => {
  return (
    <Root className={props.className}>
      <Top>
        <Left>
          <AmountFormatted
            amount={props.balanceInUsd}
            currency="$"
            roundingMode="trunc"
          />
        </Left>
        <Right>
          <Numeric value={props.balanceInUsdPercentage} preset="percents" />%
        </Right>
      </Top>
      <Progress value={props.balanceInUsdPercentage.toString()} max={100} />
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`
const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
`
const Left = styled.div`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`
const Right = styled.div`
  color: var(--text-11);
  leading-trim: both;
  text-edge: cap;
  font-size: 10px;
  font-weight: 600;
  line-height: normal;
`

const Progress = styled.progress`
  width: 100%;
  height: 4px;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 2px;
  overflow: hidden;

  &::-webkit-progress-bar {
    background-color: var(--background-3);
  }

  &::-webkit-progress-value {
    background-color: var(--up-9); // TODO: change color with red ?

    border-radius: 2px;
  }
`
